import React, { PureComponent } from 'react'
import { defineMessages, FormattedMessage } from 'react-intl'
import TextArea from 'react-textarea-autosize'
import { AdditionalInfo, Button } from 'src/Components'

import styles from './Step.module.scss'

const MESSAGES = defineMessages({
  placeholder: {
    id: 'Homeowner.cmaWizard.improvementsDescription.placeholderText',
    defaultMessage: 'E.g. Upgraded kitchen, replaced windows, etc.'
  }
})

class CMASectionImprovementsDescription extends PureComponent {
  onNext () {
    const { goForward, setAnswer } = this.props
    const answer = this.input.value

    if (answer) {
      return setAnswer({ question: 'homeUpdatedDescription', answer })
    }

    goForward()
  }

  render () {
    const { intl } = this.props

    return (
      <>
        <AdditionalInfo.Heading>
          <FormattedMessage
            id='Homeowner.cmaWizard.improvementsDescription.headline'
            defaultMessage='Optional: leave a brief description of the updates you made:'
          />
        </AdditionalInfo.Heading>
        <div>
          <TextArea
            minRows={3}
            inputRef={el => {
              this.input = el
            }}
            className={styles.textarea}
            placeholder={intl.formatMessage(MESSAGES.placeholder)}
          />
        </div>
        <Button.Group className={styles.buttonGroup}>
          <Button onClick={() => this.onNext()}>
            <FormattedMessage
              id='Homeowner.cmaWizard.improvementsDescription.improvementsButton'
              defaultMessage='Next'
            />
          </Button>
        </Button.Group>
      </>
    )
  }
}

export default CMASectionImprovementsDescription
